import React from 'react';
import {History} from 'history';
import {RouteComponentProps, withRouter} from 'react-router-dom';

import SetupTOTPForm from '../SetupTOTPForm/SetupTOTPForm';

/* eslint-disable no-unused-vars */
type LoginFormTOTPSetupProps = RouteComponentProps & {
  finishSuccessLogin: (
    data: { [key: string]: string | number | boolean },
    history: History,
  ) => void;
};
/* eslint-enable no-unused-vars */

function LoginFormTOTPSetup({
  finishSuccessLogin,
  history,
}: LoginFormTOTPSetupProps) {
  return (
    <div>
      <SetupTOTPForm
        isInitial={true}
        onSuccess={(responseData) => finishSuccessLogin(responseData, history as any)}
      />
    </div>
  );
}

export default withRouter(LoginFormTOTPSetup);
